import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { TipoPlan } from '../../models/tipo-plan/tipo-plan';

@Injectable({
  providedIn: 'root',
})
export class TiposPlanService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.TIPOS_PLAN_RADICACION_TRASLADOS}`;

  constructor(private http: HttpClient) {}

  getTiposPlanes(colectivo: string): Observable<TipoPlan[]> {
    const request = {
      jsonParametros: JSON.stringify({
        colectivo,
      }),
    };

    return this.http.post<any[]>(this.apiUrl, request).pipe(
      map((items) =>
        items.map((item) => ({
          codigo: item.codigo,
          nombre: item.tipo_plan,
          indicativo: item.indicativo,
        })),
      ),
    );
  }
}
